// Vehicles added on request (Add Vehicle) travel with the quote's main vehicle: same pickup, same AC
// choice. These helpers treat the main vehicle and the added ones as one fleet, the way the pricing
// server does.

/** "Tempo Traveller", or "2 x Innova Crysta + Swift Dzire" - repeats counted, in first-seen order. */
export function vehicleNamesLabel(vehicles) {
  const counts = new Map();
  (vehicles || []).forEach((vehicle) => {
    const name = String(vehicle?.vehicleName || vehicle?.vehicleType || "").trim();
    if (name) counts.set(name, (counts.get(name) || 0) + 1);
  });
  return Array.from(counts, ([name, count]) => (count === 1 ? name : `${count} x ${name}`)).join(" + ");
}

/**
 * The fleet as one vehicle for seat checks: seats and seat-free kids add up, and the concession age
 * is the first vehicle's. A single vehicle comes back as it is.
 */
export function combinedVehicle(vehicles) {
  const list = (vehicles || []).filter(Boolean);
  if (list.length <= 1) return list[0] || null;
  return {
    ...list[0],
    capacityMax: list.reduce((total, vehicle) => total + Number(vehicle.capacityMax || 0), 0),
    maxKidsWithoutSeat: list.reduce((total, vehicle) => total + Math.max(0, Number(vehicle.maxKidsWithoutSeat ?? 0)), 0),
  };
}

/** The vehicle rows for these ids, in order and with repeats; ids not offered are left out. */
export function vehiclesForIds(ids, vehicles) {
  return (ids || [])
    .map((id) => (vehicles || []).find((vehicle) => String(vehicle.id) === String(id)))
    .filter(Boolean);
}
